export default __webpack_public_path__ + "static/media/ferramenta-baixar-videos-img10.51f72d23.jpeg";